import { useEffect, useState } from "react";
import "../styles/preloader.css";
import logo from "../images/logo.png";

export default function Preloader({ loading }) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (!loading) {
      setFadeOut(true);
    }
  }, [loading]);

  return (
    <div id="preloader" className={fadeOut ? "fade-out" : ""}>
      <img src={logo} alt="Nick & Leila logo" className="logo" />
      {/* embossed texture / logo / monogram */}
    </div>
  );
}
